import React from 'react'

const DreadClock = () => {
  return (
    <div>
      <h1>Coming Soon!</h1> 
      <br/>
      <h3>A clock to make you question what you're doing with your life.</h3>
      <br/>
      <p>Recommended for millenials and those that want an existential crisis.</p>
      <br/><a className="fancy-button" href="/">Home</a>
    </div>
  )
}

export default DreadClock
